import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../features/auth/AuthContext';

/** Public sign-out entry for callers (e.g. Core) and residual portal sessions. */
export function LogoutPage(): JSX.Element {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        await logout();
      } catch {
        if (!cancelled) {
          setError('Signed out locally. Server revoke may have failed.');
        }
      } finally {
        if (!cancelled) {
          navigate('/login', { replace: true });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [logout, navigate]);

  return (
    <div className="route-skeleton route-skeleton--fullscreen">
      <div className="route-skeleton__pulse" />
      <p>{error ?? 'Signing out...'}</p>
    </div>
  );
}
